import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instant-home-policy',
  templateUrl: './instant-home-policy.component.html',
  styleUrls: ['./instant-home-policy.component.scss']
})
export class InstantHomePolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
